import React from "react";
import Box from "@amzn/meridian/esm/components/box";
import Button from "@amzn/meridian/esm/components/button";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import summaryStop from "../../../../images/summary_stop.svg";
import { THEME_COLOR } from "../../../../styles/colors";

/**
 * Renders a notification that the meeting summary is ready with a button to view it.
 * 
 * @param {Object} props
 * @param {string} props.aimsUuid - The ID of the ready summary
 * @param {Function} props.onViewSummary - Callback function when the "See my summary" button is clicked
 */
const SummaryReady = ({ aimsUuid, onViewSummary }) => (
  <Column alignmentHorizontal="start" width="100%" position="relative" spacing="none" spacingInset="none">
    <Row spacing="none" spacingInset="none">
      <Column width="15px" />
      <img src={summaryStop} alt="" />
    </Row>
    <Row height="16px" spacing="none" />
    <Row spacing="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
          <Box type="outline" spacingInset="none" minWidth="68px"/>
        </Theme>
        <Text type="h50">
          Your summary is ready
        </Text>
      </Row>
    </Row>
    <Row height="32px" spacing="none" />
    <Row spacing="none" spacingInset="none">
      <Row spacing="none" spacingInset="none">
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
          <Box type="outline" spacingInset="none" minWidth="68px" />
        </Theme>
        <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
          <Box type="outline" spacingInset="none">
            <Theme tokens={{ 
              buttonBackgroundColorPrimaryDefault: THEME_COLOR.TEAL_GREEN,
              buttonBackgroundColorPrimaryHover: THEME_COLOR.DEEP_TEAL,
              buttonBackgroundColorPrimaryPressed: THEME_COLOR.DARKEST_TEAL,
            }}>
              <Button size="small" onClick={onViewSummary} type="tertiary">
                See my summary
              </Button>
            </Theme>
          </Box>
        </Theme>
      </Row>
    </Row>
  </Column>
);

export default SummaryReady;
